import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom, } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IAppConfig } from '../../models/config';
@Injectable()
export class ConfigService {
  static settings: IAppConfig;
  constructor(private http: HttpClient) { }
  async load() {
    if (environment.production) {
      const jsonFile = 'assets/config/config.json';
      const response$ = this.http.get<any>(
        jsonFile,
        { observe: 'response' }
      );

      const response = await lastValueFrom(response$);
      if (response) {
        ConfigService.settings = <IAppConfig>response?.body;
      }
    } else {
      ConfigService.settings = <IAppConfig>require('../../../config.json');
    }
  }

  getStyle(styleName){
    return ConfigService?.settings?.style[styleName];
  }

  getEnvProp(propName){
    return ConfigService?.settings?.ambiente[propName];
  }

}